export const ADMIN_ROLE_KEYS = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  OPS_ADMIN: 'ops_admin',
  SUPPORT_ADMIN: 'support_admin',
  FINANCE_ADMIN: 'finance_admin',
  EXPERT_MANAGER: 'expert_manager',
  ANALYTICS_ADMIN: 'analytics_admin'
});

export const ADMIN_ROLE_LABELS_TR = Object.freeze({
  [ADMIN_ROLE_KEYS.SUPER_ADMIN]: 'Sistem Admini',
  [ADMIN_ROLE_KEYS.OPS_ADMIN]: 'Operasyon Yöneticisi',
  [ADMIN_ROLE_KEYS.SUPPORT_ADMIN]: 'Destek Yöneticisi',
  [ADMIN_ROLE_KEYS.FINANCE_ADMIN]: 'Finans Yöneticisi',
  [ADMIN_ROLE_KEYS.EXPERT_MANAGER]: 'Uzman Yöneticisi',
  [ADMIN_ROLE_KEYS.ANALYTICS_ADMIN]: 'Analitik Yöneticisi'
});

export function getAdminRoleLabel(roleKey) {
  const key = String(roleKey || '').trim().toLowerCase();
  return ADMIN_ROLE_LABELS_TR[key] || key || '-';
}
